import React, { Component } from 'react';
import './ErrorSlideIn.scss';

export interface ErrorSlideInProps {
  show: boolean;
  msg: JSX.Element;
  inTest?: boolean;
}
export interface ErrorSlideInState {
  isVisible: boolean;
}

class ErrorSlideIn extends Component<ErrorSlideInProps, ErrorSlideInState> {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: this.props.inTest ? true : false,
    };
    this.handleClose = this.handleClose.bind(this);
    document.addEventListener('keydown', this.handleClose.bind(this));
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props;
    if (prevProps.show !== show) {
      this.setState({ isVisible: show });
    }
  }

  handleClose() {
    if (this.state.isVisible) {
      this.setState({
        isVisible: false,
      });
    }
  }

  render() {
    const { msg } = this.props;
    const { isVisible } = this.state;
    if (!isVisible) {
      return null;
    }
    return (
      <div className="animated slideInDown error-slide-in">
        <span className="error-slide-in-label">Error: </span>
        <span
          dangerouslySetInnerHTML={{
            __html: !Array.isArray(msg)
              ? msg
              : msg.length === 1
              ? msg[0]
              : msg.map((message, i) => (
                  <div key={i} className="error-slide-in-multiple-error">
                    {message}
                  </div>
                )),
          }}
        />
        <span className="error-slide-in-close-btn" onClick={this.handleClose}>
          x
        </span>
      </div>
    );
  }
}

export default ErrorSlideIn;
